const OCR_CONTENT = "ocrContent";
const OCR_RESULT_STATUS = "status";
const OCR_STATUS = "OCR_STATUS";
const OCR_UPLOAD_STATUS = "OCR_UPLOAD_STATUS";
const OCR_FOLDER_NAME = "OCR_FOLDER_NAME";
const OCR_ERROR_MSG = "無辨識結果";
const OCR = "Ocr";
const OCR_GRPAH = (userId, fileName) =>
  `mnt/nmtl-static-files/original/hsna/${userId}/${fileName}/`;

export {
  OCR_STATUS,
  OCR_CONTENT,
  OCR_UPLOAD_STATUS,
  OCR_FOLDER_NAME,
  OCR_RESULT_STATUS,
  OCR_ERROR_MSG,
  OCR,
  OCR_GRPAH,
};
